import { IFitCcWorkbookTable } from './fit-cc-iworkbook-table';

export interface IFitCcWorkbookSheet 
{
    name?: string;
    tables: IFitCcWorkbookTable[];
}